import components from "./components";
import breakpoints from "./fundations/breakpoints";
import { dark, light } from "./fundations/palette";
import shadows from "./fundations/shadows";
import shape from "./fundations/shape";
import typography from "./fundations/typography";
export const getDesignTokens = (mode)=>{
    let palette;
    switch(mode){
        case "light":
            palette = light;
            break;
        case "dark":
            palette = dark;
            break;
    }
    return {
        spacing: 8,
        components,
        shape,
        palette,
        typography,
        shadows,
        breakpoints
    };
};
export default getDesignTokens;

//# sourceMappingURL=index.js.map